/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Progress_LeadInputs */

const en_features_progress_lead = /** @type {(inputs: Features_Progress_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progress you can see.`)
};

const pl_features_progress_lead = /** @type {(inputs: Features_Progress_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postępy, które widać.`)
};

/**
* | output |
* | --- |
* | "Progress you can see." |
*
* @param {Features_Progress_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_progress_lead = /** @type {((inputs?: Features_Progress_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Progress_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_progress_lead(inputs)
	return en_features_progress_lead(inputs)
});